import { useMutation, useQueryClient } from '@tanstack/react-query'

/** A mutation on one account that refreshes its detail (and the list) when it lands. */
export function useAccountAction<A, R>(accountId: string, run: (args: A) => Promise<R>) {
	const client = useQueryClient()
	return useMutation({
		mutationFn: run,
		onSuccess: () => {
			client.invalidateQueries({ queryKey: ['admin-account', accountId] })
			client.invalidateQueries({ queryKey: ['admin-accounts'] })
		},
	})
}
